import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addErrorToReport as addErrorReportThunk } from '@americanexpress/one-app-ducks';
import { MODULENAME, ROOT_ERROR_BOUNDARY } from '../../constants/constants';

class ErrorReporter extends Component {
  constructor() {
    super();
    this.handleOnError = this.handleOnError.bind(this);
    this.handleUnhandledRejection = this.handleUnhandledRejection.bind(this);
  }

  componentDidMount() {
    window.addEventListener('error', this.handleOnError);
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  componentDidCatch(error) {
    const { addErrorToReport } = this.props;
    const errorData = {
      message: error?.message,
      moduleName: MODULENAME,
      customerJourney: ROOT_ERROR_BOUNDARY,
    };
    addErrorToReport(error, errorData);
  }

  componentWillUnmount() {
    window.removeEventListener('error', this.handleOnError);
    window.removeEventListener('unhandledrejection', this.handleUnhandledRejection);
  }

  // eslint-disable-next-line max-params -- disable
  handleOnError(message, file, line, col, error) {
    const { addErrorToReport } = this.props;

    addErrorToReport(
      error,
      {
        message,
        file,
        line,
        col,
        collectionMethod: 'onerror',
        moduleName: MODULENAME,
        customerJourney: ROOT_ERROR_BOUNDARY,
      }
    );
  }

  handleUnhandledRejection(error) {
    const { addErrorToReport } = this.props;
    addErrorToReport(error, {
      moduleName: MODULENAME, message: error?.reason, customerJourney: ROOT_ERROR_BOUNDARY, collectionMethod: 'unhandledrejection',
    });
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

ErrorReporter.propTypes = {
  children: PropTypes.node,
  addErrorToReport: PropTypes.func.isRequired,
};

ErrorReporter.defaultProps = {
  children: null,
};

const mapDispatchToProps = {
  addErrorToReport: addErrorReportThunk,
};

export { ErrorReporter as TestableErrorReporter };

export default connect(null, mapDispatchToProps)(ErrorReporter);
